import { SubscriptionType, publishEvent } from '@uma/react-commons/dist/index';
import { CustomInlineNotification } from './styles';
import React, { useEffect } from 'react';
import { WarnData } from 'src/components/SubscriptionWarning/types';
import { Notification } from 'src/styles/styles';
import {
  SubscriptionWarningButtonClicked,
  SubscriptionWarningModuleDisplayed
} from 'src/utils/analytics';
import { URLS } from 'src/utils/urls';

export const SubscriptionWarning = ({ data }: WarnData) => {
  useEffect(() => {
    publishEvent(
      SubscriptionWarningModuleDisplayed(
        data.subscriptionType as SubscriptionType,
        data.subscriptionState
      )
    );
  }, [data.subscriptionState, data.subscriptionType]);

  return (
    <Notification data-testid="inline-notification">
      <CustomInlineNotification
        action={{
          action: () => {
            window.open(
              data.subscriptionType === SubscriptionType.HP_ALL_IN
                ? URLS.HpAllInOverview
                : URLS.InstantInkOverview,
              '_blank'
            );
            publishEvent(
              SubscriptionWarningButtonClicked(
                data.subscriptionType as SubscriptionType,
                data.subscriptionState
              )
            );
          },
          label: `${data.label}`
        }}
        closeButton={false}
        title={data.title}
        type={data.type}
      />
    </Notification>
  );
};

export default SubscriptionWarning;
